export const CHANGE_DS_RSLTCS = "CHANGE_DS_RSLTCS";
export const DEL_DS_RSLTCS = "DEL_DS_RSLTCS";
export const DEL_ALLDS_RSLTCS = "DEL_ALLDS_RSLTCS";
export const CHANGE_CSLINE = "CHANGE_CSLINE";
export const CHANGE_ELVDEPRDO = "CHANGE_ELVDEPRDO";
export const CHANGE_YLINECHK = "CHANGE_YLINECHK";
export const CHANGE_BORINGCHK = "CHANGE_BORINGCHK";
export const CHANGE_WLCHK = "CHANGE_WLCHK";
export const CHANGE_XSCALE = "CHANGE_XSCALE";
export const CHANGE_YSCALE = "CHANGE_YSCALE";
export const CHANGE_YLINE = "CHANGE_YLINE";
export const CHANGE_BWIDTH = "CHANGE_BWIDTH";
export const CHANGE_XLIST = "CHANGE_XLIST";
export const CHANGE_YLIST = "CHANGE_YLIST";
export const CHANGE_YLINELIST = "CHANGE_YLINELIST";
export const CHANGE_WLLINELIST = "CHANGE_WLLINELIST";
export const CHANGE_BLIST = "CHANGE_BLIST";
export const CHANGE_BLIST2 = "CHANGE_BLIST2";
export const CHANGE_PROBLIST = "CHANGE_PROBLIST";
export const CHANGE_PROBCHK = "CHANGE_PROBCHK";
export const RESET_CELL = "RESET_CELL";
export const CLICK_CELL = "CLICK_CELL";
export const CHANGE_CELLID = "CHANGE_CELLID";
export const SCR_TOP = "SCR_TOP";
export const SCR_LEFT = "SCR_LEFT";

export function changeDsAction(list, ID) {
    return {
        type: CHANGE_DS_RSLTCS,
        list: list,
        ID: ID,
    };
}

export function delDsAction(rowID) {
    return {
        type: DEL_DS_RSLTCS,
        rowID: rowID,
    };
}

export function delAllDsAction() {
    return {
        type: DEL_ALLDS_RSLTCS,
    };
}

export function changeCsLineAction(value) {
    return {
        type: CHANGE_CSLINE,
        value: value,
    };
}

export function changeElvDepRdoAction(value) {
    return {
        type: CHANGE_ELVDEPRDO,
        value: value,
    };
}

export function changeYLineChkAction(checked) {
    return {
        type: CHANGE_YLINECHK,
        checked: checked,
    };
}

export function changeBoringChkAction(checked) {
    return {
        type: CHANGE_BORINGCHK,
        checked: checked,
    };
}

export function changeWlChkAction(checked) {
    return {
        type: CHANGE_WLCHK,
        checked: checked,
    };
}

export function changeXScaleAction(scale) {
    return {
        type: CHANGE_XSCALE,
        scale: scale,
    };
}

export function changeYScaleAction(scale) {
    return {
        type: CHANGE_YSCALE,
        scale: scale,
    };
}

export function changeYLineAction(scale) {
    return {
        type: CHANGE_YLINE,
        scale: scale,
    };
}

export function changeBWidthAction(width) {
    return {
        type: CHANGE_BWIDTH,
        width: width,
    };
}

export function changeXListAction(list) {
    return {
        type: CHANGE_XLIST,
        list: list,
    };
}

export function changeYListAction(list) {
    return {
        type: CHANGE_YLIST,
        list: list,
    };
}

export function changeYLineListAction(scale) {
    return {
        type: CHANGE_YLINELIST,
        scale: scale,
    };
}

export function changeWlLineListAction(wlLineList) {
    return {
        type: CHANGE_WLLINELIST,
        wlLineList: wlLineList,
    };
}

export function changeBListAction(list) {
    return {
        type: CHANGE_BLIST,
        list: list,
    };
}

export function changeBList2Action(list) {
    return {
        type: CHANGE_BLIST2,
        list: list,
    };
}

export function changeProbListAction(list) {
    return {
        type: CHANGE_PROBLIST,
        list: list,
    };
}

export function changeProbChkAction(checked) {
    return {
        type: CHANGE_PROBCHK,
        checked: checked,
    };
}

export function resetCellAction() {
    return {
        type: RESET_CELL,
    };
}

export function clickCellAction(selIndex, dataIndex, geoIndex, prob, GL, WL, elev, dep, geoID) {
    return {
        type: CLICK_CELL,
        selIndex: selIndex,
        dataIndex: dataIndex,
        geoIndex: geoIndex,
        prob: prob,
        GL: GL,
        WL: WL,
        elev: elev,
        dep: dep,
        geoID: geoID,
    };
}

export function scrTopAction(top) {
    return {
        type: SCR_TOP,
        top: top,
    };
}

export function scrLeftAction(left) {
    return {
        type: SCR_LEFT,
        left: left,
    };
}
